import {Modal} from '@components/ui/modal/Modal.tsx'
import {FC, ReactNode} from 'react'
import {Button} from '@components/ui/button/Button.tsx'
import {Spinner} from '@components/ui/spinner/Spinner.tsx'
import {useTranslation} from 'react-i18next'
import {DefaultNamespace} from 'i18next'
import {StyledContent, StyledFooter, StyledLogoutModal} from './style'

interface LogoutModalProps {
    isLoading: boolean
    onClose: () => void
    onDelete: () => void
    title: string | DefaultNamespace
    paragraph: ReactNode
}

export const LogoutModal: FC<LogoutModalProps> = ({isLoading, onClose, onDelete, title, paragraph}) => {
    const {t} = useTranslation()

    return (
        <Modal closeIconOffset="sm" onClose={onClose} onOverlayClick={onClose}>
            <StyledLogoutModal>
                <StyledContent>
                    <h3>{title}</h3>
                    <span>{paragraph}</span>
                </StyledContent>
                <StyledFooter>
                    <Button variant="primary" onClick={onClose} disabled={isLoading}>
                        {t('commons:cancel')}
                    </Button>
                    <Button variant="secondary" onClick={onDelete} disabled={isLoading}>
                        {t('commons:confirm')}
                        {isLoading && <Spinner size={16} />}
                    </Button>
                </StyledFooter>
            </StyledLogoutModal>
        </Modal>
    )
}

LogoutModal.displayName = 'LogoutModal'
